export const config = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, "") ?? "",
  cognitoClientId: (import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined) ?? "",
  region: (import.meta.env.VITE_REGION as string | undefined) ?? "us-east-1",
};

export const SALON_TZ = "America/Chicago";
